import appStore from 'store'
import api from './api'
import { PAGINATION } from './constants'

const store = {
  namespaced: true,
  state: {
    userList: [],
    totalCount: 0,
    pagination: PAGINATION,
  },
  getters: {},
  mutations: {
    setUserList(state, payload) {
      state.userList = payload.list.slice()
      state.totalCount = payload.totalCount
    },
    setPagination(state, payload) {
      state.pagination = payload
    },
    setQueryType(state, payload) {
      state.queryType = payload
    },
    setUserinfoDetailDialogVisible(state, payload) {
      state.userinfoDetailDialogVisible = payload
    },
    setdialogVisible(state, payload) {
      state.dialogVisible = payload
    },
    setnodedetail(state, payload) {
      state.notedetail = payload
    },
    setUserinfoDetail(state, payload) {
      state.userinfoDetail = payload
    },
    setCountryCodeList(state, payload) {
      state.countryCodeList = payload
    },
  },
  actions: {
    list({ commit }, query = {}) {
      commit('setPagination', { page: query.page, size: query.size })
      api.getUserList(query).then((res) => {
        if (res.code == 0) {
          commit('setUserList', res.data)
        }
      })
    },
    upgradePartner({ commit }, data) {
      return api.upgradePartner(data).then((res) => {
        return res
      })
    },
    upgradeRate({ commit }, data) {
      return api.upgradeRate(data).then((res) => {
        return res
      })
    },
  },
}

appStore.registerModule('rebateRisk', store)
